// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 966 ? "dashboard" : chunkId) + "-legacy." + {"689":"fb17aec9","895":"024e1b9d","966":"38497c84"}[chunkId] + ".js";
};